import axios from 'axios';
/**
 * getRegulations get api
 * to regulations list */
export async function getToDoList() {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/todo_checklist`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get regulation check java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * add to checklist post api
 * to add to checklist  */
export async function updateStatus(data) {
  let result = '';
  await axios.put(`${process.env.VUE_APP_JAVA_API_URL}/todo_checklist`, data)
    .then((response) => {
      if (response.status === 200) {
        console.log('ress', response);
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('add check list java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * check readiness post api
 * to check norms readiness  */
export async function checkNormsReadiness(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/readiness_check_norms`, data)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('check norms readiness java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * check evidence readiness post api
 * to check evidence readiness  */
export async function checkEvidenceReadiness(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/readiness_check_evidences`, data)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('check readiness api java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * enable upload post api
 * to enable upload  */
export async function enableUpload(data) {
  let result = '';
  await axios.put(`${process.env.VUE_APP_JAVA_API_URL}/enable_upload`, data)
    .then((response) => {
      if (response.status === 200) {
        console.log('ress', response);
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('add check list java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * ocp mark as complete put api
 * to complete ocp document   */
export async function markAsCompleted(data) {
  let result = '';
  await axios.put(`${process.env.VUE_APP_JAVA_API_URL}/lab_mark_as_complete`, data)
    .then((response) => {
      console.log('ress', response);
      if (response.status === 204) {
        console.log('ress', response);
        result = response;
      }
    })
    .catch((err) => {
      console.log('add check list java api error', err); // eslint-disable-line no-console
    });
  return result;
}

export async function consolidateEvidences(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/consolidateEvidence`, data)
    .then((response) => {
      if (response.status === 200) {
        result = response;
      }
    })
    .catch((err) => {
      console.log('consolidate evidence java api error', err); // eslint-disable-line no-console
    });
  return result;
}

export async function downloadEvidencesZip(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/download_consolidateEvidence`, data, {
    responseType: 'blob',
  })
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('download zip java api error', err); // eslint-disable-line no-console
    });
  return result;
}

export async function emailEvidencesZip(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/products_evidences_consolidation_email`, data)
    .then((response) => {
      if (response.status === 204) {
        result = response;
      }
    })
    .catch((err) => {
      console.log('email zip java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * getReadniess post api
 * to get readiness details list */
export async function getReadinessDetails(data) {
  let result = '';
  console.log('sadasasda', data);
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/readiness_check_evidences`, data)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('email zip java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * getRegulations get api
 * to regulations list */
export async function getToDoListDetails(registrationId) {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/is_todo_check_completed/${registrationId}`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get regulation check java api error', err); // eslint-disable-line no-console
    });
  return result;
}
